export enum EShippingType {
  TRUCK = 'TRUCK',
  PUIS = 'PUIS',
  AIR = 'AIR',
  VESSEL = 'VESSEL',
}
